module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-individual-3707f383e37aab378a6e9e846e6774c2.webp";